const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const HomePage = () => import(`../views/HomePage.vue`);
// const neoAndWatsonReport = () =>
//   import("@/components/report/neoAndWatsonReport.vue");
// const examPackType3 = () => import("@/components/report/examPackType3.vue");
const helpPage = () => import("../views/helps/index.vue");

const AudioRcorded = () =>
  import("../../../components/re-design/audioRepository/AudioRepository.vue");
const logActivitiesList = () =>
  import("../views/log-activities/logActivitiesList.vue");
const systemConfiguration = () =>
  import("../views/system-configuration/systemConfiguration.vue");
const formBuilderList = () =>
  import("../views/form-builder/formBuilderList.vue");
const formBuilderCreate = () =>
  import("../views/form-builder/form-builder-create/formBuilderCreate.vue");
const formBuilderUpdate = () =>
  import("../views/form-builder/form-builder-update/formBuilderUpdate.vue");
const formBuilderView = () =>
  import("../views/form-builder/form-builder-view/formBuilderView.vue");

const userLoginHistory = () =>
  import("../views/userLoginHistory/userLoginHistoryList.vue");
const eventsManagementList = () =>
  import("../views/events-management/eventsManagementList.vue");
const eventsManagementTemplateList = () =>
  import(
    "../views/events-management-template/eventsManagementTemplateList.vue"
  );
const announcementList = () =>
  import("../views/announcement/announcementList.vue");
const baleMessenger = () => import("../views/messengers/bale/index.vue");

export const homeRoutes: any[] = [
  {
    path: "/",
    name: "home",
    meta: {
      requiresAuth: true,
    },
    redirect: "/dashboard",
    component: newContainer,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        meta: {
          label: "خانه",
          requiresAuth: true,
          redesigned: true,
        },
        component: HomePage,
      },
      {
        path: "recorded-voice",
        name: "recorded-voice",
        meta: {
          label: "صوت‌های ضبط شده",
          requiresAuth: true,
          redesigned: true,
        },
        component: AudioRcorded,
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPack1/:examPackId/:resourceCode?",
        name: "exam_pack_type_1-report",
        // component: neoAndWatsonReport,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
          redesigned: false,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPack2/:examPackId/:resourceCode?",
        name: "exam_pack_type_2-report",
        // component: neoAndWatsonReport,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
          redesigned: false,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPack3/:examPackId/:resourceCode?",
        name: "exam_pack_type_3-report",
        // component: neoAndWatsonReport,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
          redesigned: false,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPackInterview/:examPackId/:resourceCode?",
        name: "exam_pack_interview-report",
        // component: examPackType3,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
          redesigned: false,
        },
      },
      {
        name: "help",
        path: "help",
        component: null,
        redirect: "/help/research",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            name: "research_help",
            path: "research",
            component: helpPage,
            meta: {
              label: "راهنمای تحقیق",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            name: "interview_help",
            path: "interview",
            component: helpPage,
            meta: {
              label: "راهنمای مصاحبه",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            name: "kanoon_help",
            path: "kanoon",
            component: helpPage,
            meta: {
              label: "راهنمای کانون",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            name: "assessor_help",
            path: "assessor",
            component: helpPage,
            meta: {
              label: "راهنمای ارزیاب",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            name: "primary_agent_help",
            path: "primary-agent",
            component: helpPage,
            meta: {
              label: "راهنمای نماینده معاونت ابتدایی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            name: "administrative_agent_help",
            path: "administrative-agent",
            component: helpPage,
            meta: {
              label: "راهنمای نماینده امور اداری",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "login_history",
        name: "login_history",
        component: routerParent,
        redirect: "/login_history/list",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "login-history-list",
            component: userLoginHistory,
            meta: {
              label: "تاریخچه ورود کاربران",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "log-activities",
        name: "log_activities",
        component: routerParent,
        redirect: "/log-activities/list",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "log-activities-list",
            component: logActivitiesList,
            meta: {
              label: "تاریخچه تغییرات داده",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "system-configuration",
        name: "system_config",
        component: routerParent,
        redirect: "/system-configuration/configs",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "configs",
            name: "system-config-configs",
            component: systemConfiguration,
            meta: {
              label: "تنظیمات",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "form-builder",
        name: "form_builder",
        component: routerParent,
        redirect: "/form-builder/list",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "form-builder-list",
            component: formBuilderList,
            meta: {
              label: "لیست فرم‌های راهنما",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "create",
            name: "form-builder-create",
            component: formBuilderCreate,
            meta: {
              label: "فرم جدید",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/update",
            name: "form-builder-update",
            component: formBuilderUpdate,
            meta: {
              label: "فرم ویرایش",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/view",
            name: "form-builder-view",
            component: formBuilderView,
            meta: {
              label: "نمایش فرم",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
          {
            path: ":name/show",
            name: "form-builder-view-by-name",
            component: formBuilderView,
            meta: {
              label: "نمایش فرم",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "event-management",
        name: "event_management",
        component: routerParent,
        redirect: "/event-management/list",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "event-management-list",
            component: eventsManagementList,
            meta: {
              label: "مخاطب های رویداد",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "event-management-template",
        name: "event_management_template",
        component: routerParent,
        redirect: "/event-management-template/list",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "event-management-template-list",
            component: eventsManagementTemplateList,
            meta: {
              label: "مدیریت قالب‌های رویدادها",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "announcement",
        name: "announcement",
        component: routerParent,
        redirect: "/announcement/list",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "announcement-list",
            component: announcementList,
            meta: {
              label: "مدیریت اعلان‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "messengers",
        name: "messengers",
        component: routerParent,
        redirect: "/messengers/bale-connect",
        meta: {
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "bale-connect",
            name: "bale-connect",
            component: baleMessenger,
            meta: {
              label: "اتصال به بازوی اطلاع رسانی در بله",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "bale-disconnect",
            name: "bale-disconnect",
            component: baleMessenger,
            meta: {
              label: "قطع اتصال بازوی اطلاع رسانی در بله",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
];
